import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ClientPaymentMethodDto extends BaseEntityDto {
  name: string;

  toString() {
    return this.name;
  }
}
